import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'flag-3', 'IconFlag3', [["path",{"d":"M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16","key":"svg-0"}]]);